// Route paths in one place: links never hand-build URLs.
export const paths = {
  login: "/login",
  dashboard: "/",
  courses: "/courses",
  course: (id: string) => `/courses/${id}`,
  /** The course page scrolled to one unit (CurriculumCard's `unit-<id>` anchors). */
  courseUnit: (courseId: string, unitId: string) => `/courses/${courseId}#unit-${unitId}`,
  /** Courses made from a PDF/DOCX by AI. */
  courseImports: "/course-imports",
  courseImport: (id: string) => `/course-imports/${id}`,
  unitTheory: (courseId: string, unitId: string) => `/courses/${courseId}/units/${unitId}/theory`,
  lesson: (id: string) => `/lessons/${id}`,
  vocabulary: "/vocabulary",
  /** Hán Việt readings of characters and words. */
  hanviet: "/hanviet",
  readings: "/readings",
  reading: (id: string) => `/readings/${id}`,
  /** New reading prefilled by AI (draft in the navigation state). */
  readingNew: "/readings/new",
  promos: "/promos",
  promoNew: "/promos/new",
  promo: (id: string) => `/promos/${id}`,
  results: "/results",
  essays: "/essays",
  languages: "/languages",
  staff: "/staff",
  users: "/users",
  user: (id: string) => `/users/${id}`,
  classrooms: "/classrooms",
  classroom: (id: string) => `/classrooms/${id}`,
  /** Learners' reports from the friends features ("Báo cáo người dùng"). */
  friendReports: "/friend-reports",
  notifications: "/notifications",
  /** The "Tự động" tab of the notifications page. */
  automations: "/notifications?tab=automations",
  automationNew: "/notifications/automations/new",
  automation: (id: string) => `/notifications/automations/${id}`,
  feedback: "/feedback",
  /** Premium plans & prices, every subscription (admin only). */
  billing: "/billing",
  /** Behaviour analytics ("Phân tích hành vi"), admin only. */
  analytics: "/analytics",
  audit: "/audit",
  ai: "/ai",
  aiProviders: "/ai/providers",
  aiFeatures: "/ai/features",
  aiFeature: (key: string) => `/ai/features/${encodeURIComponent(key)}`,
  aiUsage: "/ai/usage",
  aiRoleplays: "/ai/roleplays", // AI group E (speaking)
  // Language centers (docs/b2b-centers-contract.md): admin pages and the center dashboard.
  orgs: "/orgs",
  org: (id: string) => `/orgs/${id}`,
  orgPricing: "/org-pricing",
  center: "/center",
  centerOrg: (id: string, tab?: string) => `/center/${id}${tab ? `?tab=${tab}` : ""}`,
  // Weekly leagues & quests (admin only).
  leagues: "/leagues",
  /** The overview of one week ("current", "previous" or its Monday). */
  leaguesWeek: (week: string) => `/leagues?week=${encodeURIComponent(week)}`,
  /** The "Đã loại" tab of the leagues page. */
  leagueExclusions: "/leagues?tab=exclusions",
  leagueCohort: (id: string) => `/leagues/cohorts/${id}`,
  questTemplates: "/quest-templates",
  /** Hardest syllables and tones of the scored recordings ("Phát âm khó"). */
  pronunciation: "/pronunciation",
  aiVoice: "/ai/voice", // ai-voice-reader: voice tutor usage
};

/**
 * Navigation state for the lesson editor: open "Tạo bài tập từ lý thuyết"
 * (AI exercises with `from_theory`) on arrival. Sent from the unit theory
 * page after it picked or created the lesson; leaves its target modal behind.
 */
export const AI_FROM_THEORY = { state: { leaveWithoutPrompt: "modal", aiFromTheory: true } } as const;

/** The lesson editor was opened with AI_FROM_THEORY. */
export const isAiFromTheory = (state: unknown) =>
  typeof state === "object" && state !== null && (state as Record<string, unknown>).aiFromTheory === true;
